import {cleaningTypeLabel} from '../service/JobTypeService';
import ImportantAcknowledgement from "./ImportantAcknowledgement";
import {getDisplayStatus, determinColor} from "../service/jobutil";
import {matchesJobStatus} from "../service/jobScheduling";
import {replaceJobSnapshot} from "../service/jobSnapshot";
import {Button, Col, Container, FormControl, Row, Spinner} from "react-bootstrap";

import DataTable from 'react-data-table-component';
import {useEffect, useRef, useState} from "react";
import {getAllJobs} from "../service/JobService";
import JobStatusToggleGroup from "./JobStatusToggleGroup";
import {getDirectoryEntriesByRole, getUsers, mapDirectoryEntriesById} from "../service/UserService";
import UpdateButtonMenu from "./UpdateJobButtonMenu";
import DateRangeSelector from "./DateRangeSelector";
import ManageJobExpand from "./ManageJobExpand";
import TaskModal from "./scheduler/TaskModal";
import {isTaskJob, buildStatusCountsWithTask, jobMatchesSearch} from "./scheduler/schedulerUtils";
import JobSourceBadge from "./JobSourceBadge";
import {loadManageJobDateRange, persistManageJobDateRange} from "./manageJobDateRange";


const customStyles = {
    rows: {
        style: {
            minHeight: '32px', // override the row height
        },
    }
};


export default function ManageJob() {
    const [isLoading, setIsLoading] = useState(false)
    const [isTaskModalOpen, setIsTaskModalOpen] = useState(false)
    const [editingTaskId, setEditingTaskId] = useState(null)
    const latestTableData = useRef([]);
    const [tableData, setTableData] = useState([])

    const [fieldWorkerArray, setFieldWorkerArray] = useState([])
    const [fieldWorkerMap, setFieldWorkerMap] = useState({})
    const [filteredData, setFilteredData] = useState([])
    const [fieldSupervisorMap, setFieldSupervisorMap] = useState({})

    const [radioValue, setRadioValue] = useState(() => {
        const radioValue = localStorage.getItem('radioValue');
        return radioValue ? radioValue : "ALL";
    });
    const [statusCounts, setStatusCounts] = useState({})

    const [selectionRange, setSelectionRange] = useState(() => loadManageJobDateRange());

    const [searchText, setSearchText] = useState(() => {
        const searchText = localStorage.getItem('searchText');
        return searchText ? searchText : "";
    });

    function openEditTaskModal(taskId) {
        setEditingTaskId(taskId);
        setIsTaskModalOpen(true);
    }

    function closeTaskModal() {
        setEditingTaskId(null);
        setIsTaskModalOpen(false);
    }

    const columns = [

        {
            name: 'ID', selector: row => row.cos_job_id, sortable: true, width: '130px',
            cell: row => (
                <span className="job-id-source-cell">
                    <JobSourceBadge job={row} compact/>
                    <span>{row.cos_job_id}</span>
                </span>
            ),
        }, {
            name: 'Job Type', selector: cleaningTypeLabel, sortable: true, width: '155px'
        }, {
            name: 'Address', selector: row => row.full_address, sortable: true, maxWidth: '200px'
        }, {
            name: 'Key', selector: row => row.key_number, sortable: true, width: '85px',
        }, {
            name: 'Customer Name', selector: row => row.cos_customer_name, sortable: true, width: '100px',
        }, {
            name: 'Agent Name', selector: row => row.agent_name, sortable: true, width: '100px',
        }, {
            name: 'Worker',
            selector: row => fieldWorkerMap[row.cos_job_worker] ? fieldWorkerMap[row.cos_job_worker] : row.cos_job_worker,
            sortable: true,
            width: '100px',
        },
        {
            name: 'Supervisor',
            selector: row => fieldSupervisorMap[row.cos_job_supervisor] ? fieldSupervisorMap[row.cos_job_supervisor] : row.cos_job_supervisor,
            sortable: true,
            width: '100px',
        },

        {
            name: 'Date', selector: row => row.date, sortable: true, width: '110px',
        }, {
            name: 'Status',
            selector: row => getDisplayStatus(row),
            cell: row => <span style={{color: determinColor(row)}}>{getDisplayStatus(row)}<ImportantAcknowledgement job={row} onUpdated={handleJobUpdated}/></span>,
            sortable: true,
            minWidth: '240px'
        }, {
            cell: row => (
                <UpdateButtonMenu
                    row={row}
                    onClick={isTaskJob(row) ? () => openEditTaskModal(row.cos_job_id) : undefined}
                />
            ), allowoverflow: true, button: "true", width: '56px',
        }];

    function handleJobUpdated(updated) {
        filterTables(latestTableData.current.map(job => job.cos_job_id === updated.cos_job_id
            ? replaceJobSnapshot(job, updated) : job), radioValue, searchText);
    }

    function refreshJobList(currentSelectionRange) {
        setFilteredData([])
        setIsLoading(true)
        getAllJobs(currentSelectionRange.startDate, currentSelectionRange.endDate).then(response => {
            if (response.status === 200) {

                response.json().then(result => {
                    filterTables(result, radioValue, searchText)
                })
            } else {
                response.text().then(result => console.log(result))
            }
        }).catch(error => console.log('error', error))
            .finally(() => {
                setIsLoading(false)
            });
    }

    function refreshUserDirectory() {
        getUsers({roles: ['WORKER', 'SUPERVISOR']}).then(response => {
            if (response.status === 200) {
                response.json().then(payload => {
                    const workers = getDirectoryEntriesByRole(payload, 'WORKER');
                    const supervisors = getDirectoryEntriesByRole(payload, 'SUPERVISOR');
                    setFieldWorkerArray(workers);
                    setFieldWorkerMap(mapDirectoryEntriesById(workers));
                    setFieldSupervisorMap(mapDirectoryEntriesById(supervisors));
                })
            } else {
                response.text().then(result => console.log(result))
            }
        }).catch(error => console.log('error', error));
    }

    useEffect(() => {
        refreshUserDirectory();
        refreshJobList(selectionRange);
    }, []);

    useEffect(() => {
        persistManageJobDateRange(selectionRange);
    }, [selectionRange]);

    function handleSelect(ranges) {
        setSelectionRange(ranges.selection);
        refreshJobList(ranges.selection);
    }

    function filterTables(rawdata, radioValue, searchText) {
        latestTableData.current = rawdata;
        let searchScopedData = rawdata
        if (searchText && searchText.length > 0) {
            searchScopedData = rawdata.filter(item => jobMatchesSearch(item, searchText, fieldWorkerMap, fieldSupervisorMap));
        }

        setStatusCounts(buildStatusCountsWithTask(searchScopedData));

        let tempData = searchScopedData
        if (radioValue === '__TASK__') {
            tempData = searchScopedData.filter((item) => isTaskJob(item));
        } else if (radioValue !== 'ALL') {
            tempData = searchScopedData.filter(item => matchesJobStatus(item, radioValue),);
        }

        setTableData(rawdata)
        setFilteredData(tempData)
    }


    function toggleRoleFilter(value) {
        setRadioValue(value)
        localStorage.setItem('radioValue', value);
        filterTables(tableData, value, searchText)
    }

    function filterSearchText(value) {
        setSearchText(value)
        localStorage.setItem('searchText', value);
        filterTables(tableData, radioValue, value)

    }

    return (<Container fluid>
            <Row>
                <Col sm={12}>
                    <Container fluid>
                        <div className="backoffice-toolbar mb-2">
                            <div className="backoffice-toolbar-status">
                                <JobStatusToggleGroup
                                    radioValue={radioValue}
                                    setRadioValue={toggleRoleFilter}
                                    statusCounts={statusCounts}/>
                            </div>
                            <div className="backoffice-toolbar-dates">
                                <DateRangeSelector
                                    startDate={selectionRange.startDate}
                                    endDate={selectionRange.endDate}
                                    onDateChange={handleSelect}
                                />
                            </div>
                            <div className="backoffice-toolbar-actions">
                                <Button variant="secondary" disabled={isLoading}
                                        onClick={() => refreshJobList(selectionRange)}
                                        className="backoffice-toolbar-refresh">
                                    {isLoading ? <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> : "Refresh"}
                                </Button>
                                <FormControl
                                    value={searchText}
                                    onChange={(e) => filterSearchText(e.target.value)}
                                    type="search"
                                    placeholder="Search"
                                    className="backoffice-toolbar-search"
                                    aria-label="Search"
                                    disabled={isLoading}
                                />
                            </div>
                        </div>
                        <Row>
                            {filteredData.length > 0 ? <DataTable
                                columns={columns}
                                data={filteredData}
                                expandableRows
                                expandableRowsComponent={ManageJobExpand}
                                expandableRowsComponentProps={{
                                    fieldWorkerMap,
                                    isLoading,
                                    onEditTask: openEditTaskModal,
                                    onJobUpdated: handleJobUpdated,
                                }}
                                customStyles={customStyles}
                                pagination
                                highlightOnHover
                                expandOnRowClicked
                            /> : <div style={{
                                height: "200px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                            <span>No Job available on Current Date and Filter <br/>
                            <a href="#" onClick={() => {
                                filterSearchText("")
                            }}>Try Clear Filter</a></span>
                            </div>}

                        </Row>
                    </Container>
                    <TaskModal
                        fieldWorkerArray={fieldWorkerArray}
                        initialDate={new Date().toISOString().slice(0, 10)}
                        onClose={closeTaskModal}
                        onSaved={() => {
                            closeTaskModal();
                            refreshJobList(selectionRange);
                        }}
                        show={isTaskModalOpen}
                        taskId={editingTaskId}
                    />


                </Col>


            </Row>


        </Container>


    );
}
